import { TippyProps } from "@tippy.js/react";
import { css } from "@emotion/react";
import theme from "theme/index";

export const defaultTippyProps: Partial<TippyProps> = {
    placement: "bottom",
    theme: "tippy-white",
    animation: "scale-subtle",
    inertia: true,
    arrow: true,
};

export const defaultTippyStyle = css`
    border-radius: 10px;
    padding: 10px;
    background-color: white;
    box-shadow: ${theme.borderAndShadow.boxShadow};
    margin-top: 10px;

    ::before {
        display: block;
        content: '';
        position: absolute;
        top: -0;
        left: 50%;
        height: 20px;
        width: 20px;
        transform: translateX(-50%) rotate(135deg);
        background-color: white;
        box-shadow: -3px 3px 3px 0 rgba(6, 0, 0, 0.3);
    }
`;

export default defaultTippyProps;
